/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { isAndroid, isIos, isSafari } from '../../services/ClientService';
import { SmartBanner } from './SmartBanner';
import { defineMessages, useIntl } from 'react-intl';
import { getAndroidAppUrl, getIosAppUrl } from '../../services/UrlService';
import { Product } from '../../services/IndexPageReaderService';

const messages = defineMessages({
  free: {
    id: 'mobileJoinPage.banner.free',
  },
  onTheAppStore: {
    id: 'mobileJoinPage.banner.appStore',
  },
  onThePlayStore: {
    id: 'mobileJoinPage.banner.playStore',
  },
  view: {
    id: 'mobileJoinPage.banner.view',
  },
});

export const SmartBannerG2M: React.FC = () => {
  const { formatMessage: f } = useIntl();

  const price = { ios: f(messages.free), android: f(messages.free) };
  const storeText = {
    ios: f(messages.onTheAppStore),
    android: f(messages.onThePlayStore),
  };
  const title = 'GoToMeeting';
  const author = 'LogMeIn, Inc.';
  const textColor = 'gray.500';

  if (isAndroid) {
    return (
      <SmartBanner
        author={author}
        buttonText={f(messages.view)}
        price={price.android}
        storeText={storeText.android}
        title={title}
        logo={`${process.env.PUBLIC_URL}/static/media/daisy-mobileG2M.svg`}
        link={getAndroidAppUrl(Product.G2M)}
        textColor={textColor}
      />
    );
  } else if (isIos && !isSafari) {
    return (
      <SmartBanner
        author={author}
        buttonText={f(messages.view)}
        price={price.ios}
        storeText={storeText.ios}
        title={title}
        logo={`${process.env.PUBLIC_URL}/static/media/daisy-mobileG2M.svg`}
        link={getIosAppUrl(Product.G2M)}
        textColor={textColor}
      />
    );
  } else {
    return null;
  }
};
